import { useAppAreaResponsiveValue } from '../../react/hooks/useAreaSize';
import useLocalStorage from '../../react/hooks/useLocalStorage';
import { isFeatureEnabled } from '../../react/services/Features';

export type PersistableNavStyle = 'compact' | 'wide';
export type NavStyle = PersistableNavStyle | 'hidden';

const defaultStylesForSizes = isFeatureEnabled('FEATURE_navigationCompact')
    ? ({
          XS: 'hidden',
          M: 'compact',
      } as const)
    : ({
          S: 'hidden',
      } as const);

export default function useNavStyle(): [NavStyle, (newState: PersistableNavStyle) => void] {
    'use memo';
    const [savedNavStyle, setSavedNavStyle] = useLocalStorage<PersistableNavStyle | null>('nav-state', null);
    const defaultNavStyle = useAppAreaResponsiveValue(defaultStylesForSizes, 'wide');

    const navStyle =
        defaultNavStyle === 'hidden'
            ? defaultNavStyle
            : (isFeatureEnabled('FEATURE_navigationCompact') && savedNavStyle) || defaultNavStyle;
    const setNavStyle = (newStyle: PersistableNavStyle) =>
        setSavedNavStyle(newStyle === defaultNavStyle ? null : newStyle);

    return [navStyle, setNavStyle];
}
